var _rect, _circle, _text, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 220",
    width: 600,
    height: 220,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 220,
    rx: 16,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 70,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 120,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Roboto",
    fontSize: 28,
    fill: "#2563eb",
    fontWeight: 700
  }, "-100%")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 80,
    width: 340,
    height: 20,
    rx: 10,
    fill: "#cfe3f7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 110,
    width: 300,
    height: 12,
    rx: 6,
    fill: "#e6edf3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 130,
    width: 320,
    height: 12,
    rx: 6,
    fill: "#e6edf3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.0d5627e1cad8498958e6e5acd97db97d.svg";
export { ForwardRef as ReactComponent };